import React, { useState } from 'react';
import { TextField, Button, Typography, Link, Box, Divider } from '@mui/material';

interface LoginFormProps {
  onSubmit: (email: string, password: string) => void;
  error: string;
  loading: boolean;
  onForgotPassword: () => void;
  onMicrosoftLogin: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ onSubmit, error, loading, onForgotPassword, onMicrosoftLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(email, password); 
  };

  return (
    <Box
      sx={{
        backgroundColor: '#004F86',
        padding: 4,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
      }}
    >
      <form onSubmit={handleLogin}>
        <TextField
          label="Correo"
          type="email"
          variant="outlined"
          fullWidth
          margin="normal"
          placeholder="Ej. personal@elecnor.cl"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          sx={{
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#ffff',
              },
              '&:hover fieldset': {
                borderColor: '#ffff',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#ffff',
              },
            },
            '& label': {
              color: '#ffff',
            },
            '& label.Mui-focused': {
              color: '#ffff',
            },
            '& input': {
              color: '#ffff',
            },
          }}
        />

        <TextField
          label="Contraseña"
          type="password"
          variant="outlined"
          fullWidth
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          sx={{
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#ffff',
              },
              '&:hover fieldset': {
                borderColor: '#ffff',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#ffff',
              },
            },
            '& label': {
              color: '#ffff',
            },
            '& label.Mui-focused': {
              color: '#ffff',
            },
            '& input': {
              color: '#ffff',
            },
          }}
        />

        {error && (
          <Typography color="error" variant="body2" sx={{ mt: 1 }}>
            <strong>{error}</strong> 
          </Typography>
        )}

        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          disabled={loading}
          sx={{
            marginTop: 2,
            backgroundColor: '#FF5E00',
            '&:hover': {
              backgroundColor: '#e04d00',
            },
          }}
        >
          Ingresar
        </Button>

        <Link
          onClick={onForgotPassword}
          href="#"
          variant="body2"
          sx={{ display: 'block', marginTop: 2, textAlign: 'center', color: '#ffff' }}
        >
          ¿Olvidaste tu contraseña?
        </Link>

        <Divider sx={{ my: 2, borderColor: 'rgba(255,255,255,0.3)' }}></Divider>

        <Button
          variant="contained"
          fullWidth
          onClick={onMicrosoftLogin}
          sx={{
            backgroundColor: '#fff',
            color: '#5E5E5E',
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '14px',
            '&:hover': { backgroundColor: '#f0f0f0' },
          }}
          startIcon={
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
              <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
              <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
              <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
            </svg>
          }
        >
          Ingresar con Microsoft
        </Button>
      </form>
    </Box>
  );
};

export default LoginForm;
